import React, { useEffect, useState } from 'react';
import { i0, i1, i2, i3, Mgnolia } from '../../assets/index';
import '../../styles/HomePageFirstComponent.css';
import { postStudentEnquiry, getGalleryImages, getPlacedStudents } from '../../services/getAllApi';

const HomePageFirstComponent = () => {
  // States and handlers remain the same
  const [scrollPosition, setScrollPosition] = useState(0);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    contact_number: '',
    course_interested: '',
    city: '',
    agree: false,
    more_info: ''
  });




  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [placedStudentData, setPlacedStudentData] = useState([])
  const [rightScrollPosition, setRightScrollPosition] = useState(0);


  const fetchCompanyImages = async () => {
    try {
      const response = await getGalleryImages("RecruiterCompanies");
      setCompanies(Array.isArray(response.data.images) ? response.data.images : []);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const CallplacedStudentData = async () => {
    getPlacedStudents()
      .then((res) => {
        if (res.status === 200) {
          setPlacedStudentData(res.data.slice().reverse())
        }

      })
  }
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/FBS Guaranteed Job MBA 2025.pdf"; // Ensure it's inside 'public' folder
    link.download = "FBS-Brochure.pdf"; // Sets the download filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  useEffect(() => {
    fetchCompanyImages()
    CallplacedStudentData()
    const scrollSpeed = 0.5;
    const maxScroll = 8 * 100;

    const animate = () => {
      setScrollPosition(prev => {
        const newPosition = prev + scrollSpeed;
        return newPosition >= maxScroll ? 0 : newPosition;
      });
      setRightScrollPosition(prev => {
        const newPosition = prev - scrollSpeed;
        return newPosition <= -maxScroll ? 0 : newPosition;
      });
      requestAnimationFrame(animate);
    };

    const animation = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animation);
  }, []);

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });


    if (!formData.first_name || !formData.last_name || !formData.email_address ||
      !formData.contact_number || !formData.course_interested || !formData.city ||
      !formData.agree) {
      setError('Please fill in all fields and agree to the terms.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await postStudentEnquiry(formData);
      if (response.status === 201 || response.status === 200) {
        setSuccessMessage('Your request has been successfully submitted!');
        setFormData({
          first_name: '',
          last_name: '',
          email_address: '',
          contact_number: '',
          course_interested: '',
          city: '',
          more_info: '',
          agree: false
        });
      } else {
        setError(JSON.stringify(response.response.data.message));
      }
    } catch (error) {
      setError('An error occurred while submitting the form.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative lg:h-[80vh] xl:h-[75vh] min-h-screen overflow-hidden">
      {/* Large Screens Layout */}
      <div className="absolute inset-0 w-full h-[100rem] z-0 sm:z-1">
        <img
          src={Mgnolia}
          className="w-full h-full object-cover"
          alt="Background"
        />
      </div>
      <div className='contact-us-section'>
        <div className="md:flex justify-center items-start" id='whole-contact'>
          <div className="left-scrollar">
            <div
              className="absolute transition-transform duration-100 ease-linear"
              style={{ transform: `translateY(${rightScrollPosition}px)` }}>
              {
                [...placedStudentData, ...placedStudentData].map((student, index) => {
                  const imageIndex = index % placedStudentData.length;
                  return (
                    <div
                      key={`up-${index}`}
                      className="w-full max-w-[15rem] mx-auto rounded-lg shadow-lg bg-white p-6 mt-[2rem]"
                    >
                      <div className="flex items-center justify-between">
                        <img
                          src={`${"https://console.fbsedu.in/storage/app/"}/${student.student_photo}`}
                          className="w-20 h-20 rounded-full object-contain"
                          alt={`Profile ${imageIndex + 1}`}
                        />
                        <div className="flex flex-col items-end">
                          <p className="text-xl mt-2 relative">{student.student_name}</p>
                          <img
                            src={`${"https://console.fbsedu.in/storage/app/"}/${student.company_logo}`}
                            className="w-[5rem] h-[4rem] max-h-16 md:max-h-20 object-contain relative right-[1.8rem]"
                            alt="Infosys Logo"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            {/* First scroll - Moving down (on the right) - Unchanged */}
            <div
              className="absolute transition-transform duration-100 ease-linear overflow-hidden relative left-[1rem] top-[2rem]"
              style={{ transform: `translateY(-${scrollPosition}px)` }}>
              {[...companies, ...companies].map((image, index) => (
                <div
                  key={`down-${index}`}
                  className="w-full max-w-[15rem] mx-auto rounded-lg shadow-lg bg-white p-1 mt-[2rem]" id='company-scrollar'
                >
                  <div className="flex items-center justify-center">
                    <img
                      src={`${"https://console.fbsedu.in/storage/app/"}/${image.image_path}`}
                      className="w-full h-auto max-h-12 md:max-h-20 object-contain"
                      alt="Infosys Logo"
                    />
                  </div>
                </div>
              ))
              }
            </div>
          </div>

          {/* Form */}
          <div className="form-section">
            <h3 className="text-2xl font-bold mb-16 text-orange-500">Enter Details</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid gap-[0.6rem] relative bottom-[2rem]">
                <div className="flex gap-4  ">
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    placeholder="First Name"
                    className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                  />
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    placeholder="Last Name"
                    className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                  />
                </div>
                <input
                  style={{ width: '100%', padding: '0.5rem' }}
                  type="tel"
                  name="contact_number"
                  value={formData.contact_number}
                  onChange={handleChange}
                  placeholder="Phone No. +91"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
                <input
                  type="email_address"
                  name="email_address"
                  value={formData.email_address}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
                <select
                name="course_interested"
                value={formData.course_interested}
                onChange={handleChange}
                className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none">
                <option value="" disabled>Course Interested</option>
                <option value="MBA in Finance">MBA in Finance</option>
              </select>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="City"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
                <input
                  type="text"
                  name="more_info"
                  value={formData.more_info}
                  onChange={handleChange}
                  placeholder="More Info"
                  className="w-full p-[0.5rem] border border-gray-300 rounded-md focus:outline-none"
                />
                <div className="flex flex-col items-start gap-4">
                  <p className="text-left text-gray-600 text-[0.6rem]">
                    By clicking the button below, you agree to receive communications via email/Call/WhatsApp/SMS from FBS-FINXL Business School.
                  </p>

                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="agree"
                      name="agree"
                      checked={formData.agree}
                      onChange={handleChange}
                      className="w-4 h-4 text-orange-500 border-gray-300 rounded focus:ring-orange-500"
                    />
                    <label htmlFor="agree" className="text-[0.7rem] text-gray-600 text-left cursor-pointer">
                      I have read and agree to FBS's <a href="/terms" className="text-orange-500 underline">terms & conditions</a>.
                    </label>
                  </div>
                  <div className="downloadB">
                    <div class="wrapper">
                      <a onClick={handleDownload} class="c-btn">
                        <span class="c-btn__label">BROCHURE
                          <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                            </path>
                          </svg>
                        </span>
                      </a>
                    </div>
                  </div>


                </div>
                {error && <p className="text-red-500">{error}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}
                <div>
                  <button
                    type="submit"
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-md"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>

      {/* ENQUIRY Button */}
      <button
        onClick={toggleModal}
        className="fixed top-[50%] right-5 bg-orange-500 text-white py-2 px-6 rounded text-xl shadow-lg hover:bg-orange-600 origin-right cursor-pointer z-50"
        style={{ rotate: '90deg' }}>
        ENQUIRY
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-full max-w-lg rounded-lg p-6 mx-4">
            <button
              onClick={toggleModal}
              className="text-red-500 float-right text-lg font-bold hover:text-red-700"
            >
              &times;
            </button>
            <h3 className="text-2xl font-bold text-center mb-4 text-orange-500">Enquiry Form</h3>
            <form onSubmit={handleSubmit} className="grid gap-4">
              <input
                type="text"
                placeholder="First Name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="Last Name"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="tel"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                placeholder="Contact Number"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="email"
                name="email_address"
                value={formData.email_address}
                onChange={handleChange}
                placeholder="Email Address"
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none"
              />
              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none"
              />
              <select
                name="course_interested"
                value={formData.course_interested}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none text-gray-400"
              >
                <option value="" disabled>Course Interested</option>
                <option value="MBA in Finance">MBA in Finance</option>
                <option value="MBA in Marketing">MBA in Marketing</option>
                <option value="MBA in HR">MBA in HR</option>
              </select>
              <textarea
                placeholder="More Info"
                name="more_info"
                value={formData.more_info}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none"
                rows="4"
              ></textarea>
              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-md"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </form>

          </div>
        </div>
      )}

    </div>

  );
};

export default HomePageFirstComponent;

